import { Injectable } from '@angular/core';
import { AnimalModel } from '../models/animal.model';
import {
  SecuringReportPreviewContactEntry,
  SecuringReportPreviewPayload,
} from '../models/securing-report-preview-payload.model';

@Injectable({ providedIn: 'root' })
export class SecuringReportPreviewBuilderService {
  build(args: {
    animal: AnimalModel | null;
    formValue: any;
    shelterId: number;
    boardMembers?: string | null;
    contacts: SecuringReportPreviewContactEntry[];
  }): SecuringReportPreviewPayload {
    const { animal, formValue, shelterId, boardMembers, contacts } = args;
    const a = animal as any;

    return {
      animal: {
        category: a?.category ?? null,
        type: a?.type ?? null,
        name: a?.name ?? null,
        birthday: a?.birthday ?? null,
        birthApprox: a?.birthApprox ?? null,
        bookNumber: a?.bookNumber ?? null,
        oldBookNumber: a?.oldBookNumber ?? null,
        oldBookNumberList: a?.oldBookNumberList ?? null,
        breed: a?.breed ?? null,
        sex: a?.sex ?? null,
        transponderNumber: a?.transponderNumber ?? null,
        tattoo: a?.tattoo ?? null,
        ringNumber: a?.ringNumber ?? null,
        specialInformation: a?.specialInformation ?? null,
        coatType: a?.coatType ?? null,
        coatColor: a?.coatColor ?? null,
        badge: a?.badge ?? null,
        specialNotice: a?.specialNotice ?? null,
      },
      animalOrigin: {
        dateOfReceipt: formValue.dateOfReceipt ?? null,
        foundStatus: 'secured',
        specialInformation: formValue.specialInformation ?? null,
        foundDateTime: formValue.foundDateTime ?? null,
        pickupUserName: formValue.pickupUserName ?? null,
        pickupDateTime: formValue.pickupDateTime ?? null,
        consentToShareWithOwner: !!formValue.consentToShareWithOwner,
        location: formValue.originLocation ?? null,
        careCondition: (formValue.careCondition ?? []) as string[],
        temperament: (formValue.temperament ?? []) as string[],
        bcsNutrition: formValue.bcsNutrition ?? null,

        handoverAuthority: formValue.handoverAuthority ?? null,
        handoverResponsibleContact: formValue.handoverResponsibleContact ?? null,
        ownerPresentAtHandover: !!formValue.ownerPresentAtHandover,

        securingReasons: formValue.securingReason ? [formValue.securingReason] : [],
        securingReasonOther: formValue.securingReasonOther ?? null,
        incidentCourse: formValue.incidentCourse ?? null,
        operationDescription: formValue.operationDescription ?? null,

        biteVictimType: formValue.biteVictimType ?? null,
        biteVictimGender: formValue.biteVictimGender ?? null,
        biteVictimAge: formValue.biteVictimAge ?? null,

        housingConditionsDescription: formValue.housingConditionsDescription ?? null,
        otherAnimalsLeftOnSite: !!formValue.otherAnimalsLeftOnSite,
        otherAnimalsDescription: formValue.otherAnimalsDescription ?? null,

        handedOverEquipment: formValue.handedOverEquipment ?? null,
        handoverHealthStatus: (formValue.handoverHealthStatus ?? []) as string[],
        needsImmediateVetCare: !!formValue.needsImmediateVetCare,
        healthDescription: formValue.healthDescription ?? null,
        behaviourAtHandover: formValue.behaviourAtHandover ?? null,

        operationStartAt: formValue.operationStartAt ?? null,
        operationEndAt: formValue.operationEndAt ?? null,

        handoverPartySignature: formValue.handoverPartySignature ?? null,
        presentShelterStaff: (formValue.presentShelterStaff ?? []).map((id: number) => ({ id })),
        finderSignature: formValue.finderSignature ?? null,
        employeeSignature: formValue.employeeSignature ?? null,
        signatureLocation: formValue.signatureLocation ?? null,
        signatureDate: formValue.signatureDate ?? null,
      },
      contacts,
      animalShelter: { id: shelterId, boardMembers: boardMembers ?? null },
    };
  }
}
